import React from 'react';

/**
 * Dashboard footer branding panel � spans the full grid width.
 */
export default function BrandingPanel() {
  return (
    <div className="branding-panel">
      <div className="branding-panel-copy">
        <h2 className="branding-panel-title">Wireless Construction Cameras</h2>
        <p className="branding-panel-text">
          Our cameras are purpose-built for construction from the ground up.
          Bedrock eliminates all of the shortcomings of DIY cameras and rivals
          the best commercial systems on the market at a fraction of the price.
          Your camera system should work as hard as you do.
        </p>
      </div>
      <div className="branding-panel-tagline">
        Live View + Timelapse&nbsp;&nbsp;|&nbsp;&nbsp;Smart Detection&nbsp;&nbsp;|&nbsp;&nbsp;Real-time Alerts
      </div>
    </div>
  );
}
